import React, { useContext } from 'react';
// import classNames from 'classnames';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import { EDTextEdit } from '../../../../../../../../../../BaseComponents/TextEdit/EDTextEdit';
import { EkonomiskAnalysSelectContext } from '../../../Components/AnalysSelect/Context/EkonomiskAnalysSelectContext';
import EDIcon from '../../../../../../../../../../BaseComponents/Icon/EDIcon';
import { useIsTouchDevice } from '../../../../../../../../../../Components/BreakpointContext/BreakpointContextUtils';

interface IProps {
  selectListOpen: boolean;
  onSearchValueChanged: (newValue: string) => void;
  onSearchInputClicked?: () => void;
  openFullscreen?: (callback: () => void) => void;
  searchValue: string;
  analysNamn?: string;
  hideLabel?: boolean;
  displayValue: string | null;
  setDisplayValue?: (newValue: string) => void;
  label: string;
  fullscreen?: boolean;
  captureInputRef?: boolean;
  classes?: Partial<Record<keyof ReturnType<typeof styles>, string>>;
  className?: string;
}

const styles = (theme: Theme) =>
  ({
    label: {},
    labelFocused: {},
    underline: {},
    inputSelected: {
      fontWeight: 600,
    },
    inputFocused: {},
    hiddenLabel: {
      visibility: 'hidden',
    },
    tooltip: {
      marginLeft: '-240px',
    },
    textColor: {
      color: 'inherit',
    },
    inputFullScreen: {
      color: theme.palette.common.white,
    },
    resetButton: {
      marginRight: theme.spacing(2),
    },
    input: {},
  } as const);

const onTextEditClick =
  (
    selectListOpen: boolean,
    isTouchDevice: boolean,
    searchInputClicked?: () => void,
    openFullScreen?: (callback: () => void) => void
  ) =>
  (event: React.MouseEvent<unknown, MouseEvent>) => {
    if (selectListOpen || isTouchDevice) {
      event.stopPropagation();
    }

    /* 
    Notering: TODO Enligt EK-4380 så finns det en bugg med TouchFullscreen komponenten på vissa devices
    vi stänger av fullscreen-läget tills vi kan åtgärda stylingbuggarna. Se task EK-4390 för detta
  */

    // if (isTouchDevice && openFullScreen && searchInputClicked) {
    //   openFullScreen(searchInputClicked);
    // } else if (searchInputClicked) {
    //   searchInputClicked();
    // }

    if (searchInputClicked) {
      searchInputClicked();
    }
  };

const EkonomiskAnalysSelectSearch: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { selectInputRef } = useContext(EkonomiskAnalysSelectContext);
  const isTouchDevice = useIsTouchDevice();

  const onBlur = () => {
    if (
      props.analysNamn &&
      !props.searchValue &&
      props.setDisplayValue &&
      (!isTouchDevice || props.fullscreen)
    ) {
      props.setDisplayValue(props.analysNamn);
    }
  };

  const value =
    props.displayValue != null ? props.displayValue : props.searchValue;
  return (
    <>
      <EDTextEdit
        onClick={onTextEditClick(
          props.selectListOpen,
          isTouchDevice,
          props.onSearchInputClicked,
          props.openFullscreen
        )}
        staticLabel
        label={props.label}
        allMargins="none"
        inputRef={props.captureInputRef ? selectInputRef : undefined}
        value={value}
        onChange={props.onSearchValueChanged}
        onBlur={onBlur}
        autoFocus={
          (props.displayValue == null && props.selectListOpen) ||
          props.fullscreen
        }
        hideClearIcon
        simpleLine
        paddingLeft={2}
      />
      {!props.fullscreen && (
        <EDIcon
          iconType={props.selectListOpen ? 'expand_less' : 'expand_more'}
        />
      )}
    </>
  );
};

export default withStyles(EkonomiskAnalysSelectSearch, styles);
